<template>
  <div class="dg-page">
    <!-- 封面 -->
    <div class="cover">
      <div class="sys">YUNTIAN GOU · 图书荐购与馆配服务平台</div>
      <h1>实现师生学号、工号免注册登录</h1>
      <div class="sub">平台部署与功能交付流程说明（实施 / 验收截图依据）</div>
      <div class="meta">
        <span><b>需求名称：</b>师生学号 / 工号免注册登录</span>
        <span><b>文档类型：</b>部署与交付清单</span>
        <span><b>编制：</b>研发部</span>
        <span><b>更新日期：</b>2026-08-11</span>
      </div>
    </div>

    <div class="body">
      <h2 class="sec">文档信息</h2>
      <table class="info-table">
        <tr><th>需求名称</th><td>实现师生学号、工号免注册登录</td></tr>
        <tr><th>目标说明</th><td>师生凭本校学号 / 工号即可免注册直接登录平台，无需单独注册账号；按二级学院、专业团队、图书馆馆员等维护用户身份，支撑多维度荐购统计。</td></tr>
        <tr><th>交付范围</th><td>平台部署 + 承诺函 + 荐购全流程（规则 / 审核 / 统计 / 导出）+ 常规荐购 + 多维度检索 + 特色图书 + 图书查重等（详见下文十一条清单）</td></tr>
        <tr><th>配套要求</th><td>研发整理简单部署流程并补充软著；标书承诺合同签订后 7 个工作日内完成部署，具备图书荐购、查重等采编配套工作。</td></tr>
        <tr><th>读者 / 馆员入口</th><td>浏览器访问站点域名即可，无需安装客户端</td></tr>
      </table>

      <h2 class="sec">交付清单总览</h2>
      <p class="muted">本需求共包含以下 11 项交付内容，逐项对应实施与验收截图依据：</p>
      <div class="overview">
        <span>一、平台部署</span>
        <span>二、承诺函</span>
        <span>三、平台荐购功能截图</span>
        <span>四、荐购规则设置</span>
        <span>五、荐购审核</span>
        <span>六、荐购统计</span>
        <span>七、常规荐购功能</span>
        <span>八、多维度检索功能</span>
        <span>九、特色图书</span>
        <span>十、图书种类</span>
        <span>十一、图书查重功能</span>
      </div>

      <!-- 一、平台部署 -->
      <div class="module">
        <div class="module-head">一、平台部署（简单部署流程，补软著）</div>
        <div class="module-body">
          <p>研发整理一份简单的部署流程文档（需补充软著）。平台采用「前端静态资源 + Nginx 反向代理后端接口」的标准部署方式，读者 / 馆员通过浏览器访问站点域名即可使用，无需安装客户端。</p>
          <div class="shot"><b>截图位 1：</b>部署流程文档（含软著登记信息）</div>

          <h3 class="sub">部署架构</h3>
          <div class="arch">
            <div class="arch-row">
              <div class="node">浏览器 / 读者端<small>PC Web 访问</small></div>
              <div class="arrow">→</div>
              <div class="node">Nginx 服务器<small>静态资源 + 反向代理</small></div>
              <div class="arrow">→</div>
              <div class="node">后端服务接口<small>/sxtucaihui → 业务服务</small></div>
              <div class="arrow">→</div>
              <div class="node">数据库 / 馆藏<small>业务数据</small></div>
            </div>
            <div class="arch-note">前端所有页面均为静态文件；仅以 <code>/sxtucaihui</code> 开头的接口请求会被 Nginx 转发至后端。</div>
          </div>

          <h3 class="sub">部署步骤</h3>
          <div class="step">
            <div class="step-head"><span class="num">1</span> 获取前端源码并安装依赖</div>
            <div class="step-body">
              <pre><span class="c"># 进入前端工程目录</span>
<span class="k">cd</span> recommendedpurchaseandtch-web
<span class="c"># 安装依赖</span>
<span class="k">npm</span> install</pre>
            </div>
          </div>
          <div class="step">
            <div class="step-head"><span class="num">2</span> 构建前端静态资源</div>
            <div class="step-body">
              <pre><span class="c"># 生产构建，输出 dist/ 目录</span>
<span class="k">npm</span> run build</pre>
            </div>
          </div>
          <div class="step">
            <div class="step-head"><span class="num">3</span> 安装 Nginx 并上传 dist</div>
            <div class="step-body">
              <pre><span class="c"># 安装并启动 Nginx</span>
<span class="k">yum</span> install -y nginx
<span class="k">systemctl</span> enable nginx
<span class="k">systemctl</span> start nginx</pre>
              <p class="muted">将 <code>dist</code> 上传至站点根目录（如 <code>/usr/share/nginx/html/ytg</code>）。</p>
            </div>
          </div>
          <div class="step">
            <div class="step-head"><span class="num">4</span> 配置 Nginx（静态托管 + 接口反代）</div>
            <div class="step-body">
              <pre>server {
    listen 80;
    server_name  yuntiango.example.com;
    root  /usr/share/nginx/html/ytg;
    index index.html;
    location / { try_files $uri $uri/ /index.html; }
    <span class="c"># 后端接口反向代理</span>
    location /sxtucaihui/ {
        proxy_pass http://192.168.7.88:21002/pb/;
    }
}</pre>
            </div>
          </div>
          <div class="step">
            <div class="step-head"><span class="num">5</span> 校验并重载上线</div>
            <div class="step-body">
              <pre><span class="k">nginx</span> -t
<span class="k">nginx</span> -s reload</pre>
            </div>
          </div>
          <div class="shot"><b>截图位 2：</b>Nginx 配置与 <code>nginx -t</code> 校验通过界面</div>
        </div>
      </div>

      <!-- 二、承诺函 -->
      <div class="module">
        <div class="module-head">二、承诺函</div>
        <div class="module-body">
          <p>标书员承诺：合同签订后 <b>7 个工作日内</b>完成部署，具备图书荐购、查重等采编配套工作。</p>
          <div class="shot"><b>截图位 3：</b>承诺函扫描件 / 盖章页</div>
        </div>
      </div>

      <!-- 三、平台荐购功能截图 -->
      <div class="module">
        <div class="module-head">三、平台荐购功能截图</div>
        <div class="module-body">
          <p>展示平台图书荐购核心功能界面，作为交付与验收的直观依据。</p>
          <div class="shot"><b>截图位 4：</b>平台荐购功能主界面（图书详情 / 加入荐购 / 购物车）</div>
        </div>
      </div>

      <!-- 四、荐购规则设置 -->
      <div class="module">
        <div class="module-head">四、荐购规则设置</div>
        <div class="module-body">
          <p>管理后台配置图书荐购规则（一般荐购规则、荐购直邮规则、荐购直邮配置等），控制可荐购范围、册数、金额等参数。</p>
          <div class="shot"><b>截图位 5：</b>荐购规则设置页（规则参数配置界面）</div>
        </div>
      </div>

      <!-- 五、荐购审核 -->
      <div class="module">
        <div class="module-head">五、荐购审核</div>
        <div class="module-body">
          <p>馆员在后台对师生提交的荐购请求进行审核处理（一般荐购处理、荐购直邮处理、荐购订单汇总等）。</p>
          <div class="shot"><b>截图位 6：</b>荐购审核处理界面（待处理 / 已处理列表）</div>
        </div>
      </div>

      <!-- 六、荐购统计 -->
      <div class="module">
        <div class="module-head">六、荐购统计（3.1 添加用户 / 3.2 多维度统计 / 3.3 数据导出）</div>
        <div class="module-body">
          <h3 class="sub">3.1 添加用户</h3>
          <p>前期可通过管理员账号，按<b>二级学院、专业团队、图书馆馆员</b>等新增用户，并设置对应的用户身份（如下图所示），以便于后期平台多维度荐购统计。</p>
          <div class="shot"><b>截图位 7：</b>用户管理 — 按二级学院 / 专业团队 / 馆员新增用户并设置身份</div>

          <h3 class="sub">3.2 多维度统计（需研发）</h3>
          <p>提供多维度荐购统计：在「荐购汇总」页支持按二级学院 / 专业团队 / 时间段 / 荐购人身份 / 图书分类等维度统计荐购总量、通过量、驳回量、待审核量；并在各状态页（荐购汇总 / 待审核 / 审核通过 / 审核驳回）展示中图法分类、学科分类、荐购人身份三块汇总，便于数据导出截图。</p>
          <div class="shot"><b>截图位 8：</b>多维度荐购统计页（含三块分类汇总 + 合计行）</div>

          <h3 class="sub">3.3 数据导出</h3>
          <p>点击「导出」可弹出保存格式选择，提供 <b>Excel</b> 与 <b>PDF</b> 两种导出格式（见上图导出格式下拉）。</p>
          <div class="shot"><b>截图位 9：</b>导出格式弹窗（Excel / PDF 两个选项）</div>
        </div>
      </div>

      <!-- 七、常规荐购功能 -->
      <div class="module">
        <div class="module-head">七、常规荐购功能（4.1 常规荐购 / 4.2 无书目荐购）</div>
        <div class="module-body">
          <h3 class="sub">4.1 常规荐购</h3>
          <p>师生在平台按书名 / 作者 / ISBN 等检索图书并提交荐购。</p>
          <div class="shot"><b>截图位 10：</b>常规荐购流程界面（检索 → 加入荐购）</div>

          <h3 class="sub">4.2 无书目荐购</h3>
          <p>对于平台暂无书目的图书，师生可通过无书目荐购通道提交荐购申请（填写书名、作者、出版社等信息）。</p>
          <div class="shot"><b>截图位 11：</b>无书目荐购录入界面</div>
        </div>
      </div>

      <!-- 八、多维度检索功能 -->
      <div class="module">
        <div class="module-head">八、多维度检索功能（5.1 查询或高级检索 / 5.2 检索截图）</div>
        <div class="module-body">
          <h3 class="sub">5.1 点击首页查询或高级检索</h3>
          <p>平台提供首页快捷查询与高级检索入口，支持按中图法分类、学科、出版社、出版时间等多维度筛选。</p>
          <h3 class="sub">5.2 多维度检索功能截图</h3>
          <div class="shot"><b>截图位 12：</b>多维度检索结果界面（筛选条件 + 结果列表）</div>
        </div>
      </div>

      <!-- 九、特色图书 -->
      <div class="module">
        <div class="module-head">九、特色图书（6.1 特色专区 / 6.2 图书信息 / 6.3 marc编目字段）</div>
        <div class="module-body">
          <h3 class="sub">6.1 特色专区</h3>
          <p>平台提供特色图书专区，聚合专题书单 / 馆配特色资源。</p>
          <div class="shot"><b>截图位 13：</b>特色专区界面</div>

          <h3 class="sub">6.2 图书信息</h3>
          <p>在荐购功能下查看图书信息，操作按钮应显示为「<b>荐购</b>」（而非「加入购物车」）。</p>
          <div class="shot"><b>截图位 14：</b>图书详情页（操作按钮为「荐购」）</div>

          <h3 class="sub">6.3 marc编目字段</h3>
          <p>图书详情支持查看 MARC 编目字段，馆员可编辑 MARC 数据。</p>
          <div class="shot"><b>截图位 15：</b>MARC 编目字段查看 / 编辑界面</div>
        </div>
      </div>

      <!-- 十、图书种类 -->
      <div class="module">
        <div class="module-head">十、图书种类（平台储备正版图书 591 万种）</div>
        <div class="module-body">
          <p>平台储备正版图书 <b>591 万种</b>，覆盖各中图法分类与学科，满足师生多样化荐购需求。</p>
          <div class="shot"><b>截图位 16：</b>图书种类 / 馆藏规模说明页</div>
        </div>
      </div>

      <!-- 十一、图书查重功能 -->
      <div class="module">
        <div class="module-head">十一、图书查重功能</div>
        <div class="module-body">
          <p>采购人可将图书馆馆藏导入到平台，实现查重功能；在选购、荐购图书时提示是否与馆藏重复，避免重复采购。</p>
          <div class="shot"><b>截图位 17：</b>馆藏导入界面 + 荐购 / 选购时的「与馆藏重复」提示</div>
        </div>
      </div>
    </div>

    <div class="footer">
      云田购 · 图书荐购与馆配服务平台 &nbsp;|&nbsp; 实现师生学号、工号免注册登录 — 部署与交付流程说明 &nbsp;|&nbsp; 本文档用于实施部署与验收截图
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeployGuide'
}
</script>

<style scoped>
  .dg-page {
    --brand: #ca1a1b;
    --brand-light: #fbeaea;
    --ink: #303133;
    --sub: #606266;
    --line: #ebeef5;
    --bg: #f5f7fa;
    --code-bg: #2b2f36;
    --code-ink: #e6e6e6;
    max-width: 1080px;
    margin: 0 auto;
    background: #fff;
    padding: 0 0 48px;
    box-shadow: 0 0 24px rgba(0, 0, 0, .06);
    color: var(--ink);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Microsoft YaHei", "PingFang SC", sans-serif;
    line-height: 1.7;
    font-size: 14px;
  }
  /* 封面头 */
  .cover {
    background: linear-gradient(135deg, #ca1a1b 0%, #a11415 100%);
    color: #fff;
    padding: 40px 48px 34px;
  }
  .cover .sys {
    font-size: 13px;
    letter-spacing: 2px;
    opacity: .85;
    margin-bottom: 8px;
  }
  .cover h1 {
    margin: 0;
    font-size: 30px;
    font-weight: 700;
    letter-spacing: 1px;
  }
  .cover .sub {
    margin-top: 10px;
    font-size: 15px;
    opacity: .92;
  }
  .cover .meta {
    margin-top: 22px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px 28px;
    font-size: 13px;
    opacity: .9;
  }
  .cover .meta b { font-weight: 600; }

  .body { padding: 30px 48px 0; }

  /* 文档信息表 */
  .info-table {
    width: 100%;
    border-collapse: collapse;
    margin: 6px 0 28px;
    font-size: 13px;
  }
  .info-table th, .info-table td {
    border: 1px solid var(--line);
    padding: 9px 12px;
    text-align: left;
    vertical-align: top;
  }
  .info-table th {
    background: var(--bg);
    color: var(--sub);
    font-weight: 600;
    width: 130px;
    white-space: nowrap;
  }

  h2.sec {
    font-size: 20px;
    color: var(--brand);
    border-left: 5px solid var(--brand);
    padding-left: 12px;
    margin: 36px 0 16px;
  }
  h3.sub {
    font-size: 15px;
    color: var(--ink);
    margin: 22px 0 10px;
  }
  p { margin: 8px 0; color: var(--ink); }
  .muted { color: var(--sub); }

  /* 交付清单总览 */
  .overview {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 12px 0 8px;
  }
  .overview span {
    background: var(--brand-light);
    color: var(--brand);
    border: 1px solid #f1c9c9;
    border-radius: 14px;
    padding: 5px 14px;
    font-size: 13px;
    font-weight: 600;
  }

  /* 模块卡片 */
  .module {
    border: 1px solid var(--line);
    border-radius: 8px;
    margin: 16px 0;
    overflow: hidden;
  }
  .module-head {
    background: var(--brand-light);
    padding: 10px 16px;
    font-weight: 700;
    color: var(--brand);
    font-size: 15px;
  }
  .module-body { padding: 14px 18px; }

  /* 架构图 */
  .arch {
    border: 1px solid var(--line);
    border-radius: 8px;
    padding: 22px;
    background: #fafafa;
    margin: 12px 0 8px;
  }
  .arch-row {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 14px;
    flex-wrap: wrap;
  }
  .node {
    background: #fff;
    border: 1px solid var(--brand);
    color: var(--brand);
    border-radius: 6px;
    padding: 12px 16px;
    min-width: 150px;
    text-align: center;
    font-weight: 600;
  }
  .node small { display: block; font-weight: 400; color: var(--sub); margin-top: 4px; font-size: 12px; }
  .arrow {
    align-self: center;
    color: var(--brand);
    font-size: 22px;
    font-weight: 700;
  }
  .arch-note { text-align: center; color: var(--sub); font-size: 12px; margin-top: 14px; }

  /* 步骤 */
  .step {
    border: 1px solid var(--line);
    border-radius: 8px;
    margin: 14px 0;
    overflow: hidden;
  }
  .step-head {
    background: #fff5f5;
    padding: 10px 16px;
    font-weight: 700;
    color: var(--brand);
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .step-head .num {
    background: var(--brand);
    color: #fff;
    width: 24px; height: 24px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    flex: none;
  }
  .step-body { padding: 14px 18px; }

  /* 代码块 */
  pre {
    background: var(--code-bg);
    color: var(--code-ink);
    padding: 14px 16px;
    border-radius: 6px;
    overflow-x: auto;
    font-size: 12.5px;
    line-height: 1.6;
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
    margin: 10px 0;
  }
  pre .c { color: #8b949e; }
  pre .k { color: #ff7b72; }
  pre .s { color: #a5d6ff; }

  /* 截图占位 */
  .shot {
    border: 2px dashed #c9ccd1;
    border-radius: 6px;
    background: repeating-linear-gradient(45deg, #fafafa, #fafafa 12px, #f0f2f5 12px, #f0f2f5 24px);
    color: #9aa0a6;
    text-align: center;
    padding: 22px 10px;
    margin: 12px 0;
    font-size: 13px;
  }
  .shot b { color: var(--sub); }

  .footer {
    margin-top: 40px;
    padding: 18px 48px;
    border-top: 1px solid var(--line);
    color: var(--sub);
    font-size: 12px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/Xtch/DeployGuide.vue